import { SVGProps } from 'react';

const Lasso = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M3.704 14.467C2.594 13.147 2 11.591 2 10c0-2.122 1.054-4.157 2.929-5.657S9.348 2 12 2s5.196.843 7.071 2.343S22 7.878 22 10s-1.054 4.157-2.929 5.657S14.652 18 12 18c-1.827 0-3.619-.4-5.181-1.158M7 22a5 5 0 0 1-2-3.994M7 16a2 2 0 1 1-4 0 2 2 0 0 1 4 0"
    />
  </svg>
);
export default Lasso;
